'use client';
import { jsx as e, jsxs as s } from "react/jsx-runtime";
import { Icon as u } from "@tameeni/icons";
import { useMediaQuery as k, cn as o } from "@tameeni/shared-logic";
import { HomeLogo as f } from "../shared-pages-components/src/components/home-logo.js";
import { AppDownloadSection as w } from "../shared-pages-components/src/components/app-download-section.js";
import { Accordion as A } from "@tameeni/ui";
import * as y from "react";
import { FooterItem as x } from "./components/footer-item.js";
import { FollowUs as L } from "./components/social-follow-us.js";
import { getProductLinks as N, getSupportLinks as T } from "./helpers/constants.js";
import { footerTranslations as m } from "./helpers/translation.js";
const U = ({
  locale: r = "ar",
  isNav: t = !1,
  rootHref: c,
  links: n,
  productsToShow: a,
  supportLinks: p = [],
  resourcesLinks: d = []
}) => {
  const i = k("(max-width: 992px)"), h = y.useCallback(() => {
    if (t) return null;
    if (!n || !a) return;
    const g = [
      {
        title: m.productLinks[r].title,
        links: N(r, n, a)
      },
      {
        title: m.supportLinks[r].title,
        links: T(r, p)
      },
      {
        title: m.resourceLinks[r].title,
        links: d
      }
    ];
    return i ? /* @__PURE__ */ e(
      A,
      {
        type: "single",
        collapsible: !0,
        className: "col-span-1 border-y-slate-300 border-b py-2",
        children: g.map((l) => /* @__PURE__ */ e(
          x,
          {
            title: l.title,
            links: l.links,
            isMobile: i
          },
          l.title
        ))
      }
    ) : g.map((l) => /* @__PURE__ */ e("div", { className: "order-2", children: /* @__PURE__ */ e(
      x,
      {
        title: l.title,
        links: l.links,
        isMobile: i
      }
    ) }, l.title));
  }, [
    i,
    t,
    n,
    r,
    a,
    d,
    p
  ]), b = /* @__PURE__ */ s(
    "div",
    {
      className: o(
        "flex flex-col rtl:items-start min-w-fit order-2 lg:order-1",
        t && "mb-2"
      ),
      children: [
        !t && /* @__PURE__ */ e("span", { className: "mb-8 hidden lg:block", children: /* @__PURE__ */ e(f, { isFooter: !0, href: c, locale: r }) }),
        /* @__PURE__ */ e("div", { className: "my-4", children: /* @__PURE__ */ e(L, { isMobile: i, locale: r }) }),
        /* @__PURE__ */ e("span", { className: "bg-slate-300 w-full block h-px lg:bg-transparent" }),
        /* @__PURE__ */ s("div", { className: "flex flex-col gap-3 my-4", children: [
          /* @__PURE__ */ s("p", { className: "text-xs text-slate-700 flex flex-row items-center gap-2", children: [
            /* @__PURE__ */ e("span", { children: r === "en" ? "Powered and operated by:" : "تطوير وتشغيل:" }),
            /* @__PURE__ */ e("a", { href: "https://www.rasan.co/", target: "_blank", rel: "noreferrer", children: /* @__PURE__ */ e(u, { name: "RasanLogo", className: "h-[10px] w-[48px]" }) })
          ] }),
          /* @__PURE__ */ e("p", { className: "text-xs text-slate-700 max-w-80", children: r === "en" ? "Copyright © Tameeni 2025. All rights reserved. Company Tameeni LOSATA AL-TAMIN AL-ALAKTAROUNI" : "© تأميني 2025. جميع الحقوق محفوظة شركة تأميني لوساطة التأمين الالكتروني شركة شخص واحد" })
        ] })
      ]
    }
  );
  return /* @__PURE__ */ s(
    "footer",
    {
      className: o("bg-slate-50 border-t  border-slate-100", !t && "py-8"),
      children: [
        /* @__PURE__ */ s(
          "section",
          {
            className: o(
              "gap-0 lg:gap-[7.1875rem] grid grid-cols-1 lg:grid-cols-4",
              t ? "px-4 lg:grid-cols-1" : "box"
            ),
            children: [
              !t && /* @__PURE__ */ e("span", { className: "mb-8 block lg:hidden", children: /* @__PURE__ */ e(f, { isFooter: !0, href: c, locale: r }) }),
              b,
              h()
            ]
          }
        ),
        /* @__PURE__ */ s("section", { className: o(!t && "box"), children: [
          !t && /* @__PURE__ */ e("span", { className: "block w-full grid-cols-4 h-[0.5px] bg-slate-300" }),
          /* @__PURE__ */ e(
            "div",
            {
              className: o(
                "mx-auto flex flex-col lg:flex-row justify-center gap-4 lg:gap-8",
                t ? "px-4" : "mt-4 lg:mt-8"
              ),
              children: /* @__PURE__ */ e(
                w,
                {
                  englishTitle: "Download Tameeni App",
                  arabicTitle: "حمل تطبيق تأميني الآن",
                  locale: r,
                  isNav: t,
                  iconClassName: "max-w-[6.875rem]"
                }
              )
            }
          )
        ] })
      ]
    }
  );
};
export {
  U as Footer
};
//# sourceMappingURL=footer.js.map
